import { render, staticRenderFns } from "./StarField.vue?vue&type=template&id=b47b080e&"
import script from "./StarField.vue?vue&type=script&lang=js&"
export * from "./StarField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports